export const parseNumber = (value: string) => {
  if (!value) return null;
  const num = Number(value);
  if (!num || isNaN(num)) return null;
  const rounded = Math.round(num * 100) / 100;
  if (Number.isInteger(rounded)) {
    return rounded;
  }
  return rounded;
};
